
function is_string(obj){
    return typeof obj === "string";
}

function isset(obj){
    return typeof obj !== 'undefined';
}

/******************************************************************
 *
 * 空判定
 *
 ******************************************************************/
// Speed up calls to hasOwnProperty
var hasOwnProperty = Object.prototype.hasOwnProperty;

function empty(obj) {

    // null and undefined are "empty"
    if (obj == null || typeof obj === 'undefined') {
        return true;
    }

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) {
        return false;
    }

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) {
            return false;
        }
    }

    if (Array.isArray(obj) && obj.length === 0) {
        return true;
    }

    return true;
}

/******************************************************************
 *
 * オブジェクトかどうか
 *
 ******************************************************************/
function is_object(mixed) {
    return typeof mixed === 'Object' || typeof mixed === 'object';
}

/******************************************************************
 *
 * 配列の中にキーを含んでいるかどうか
 *
 ******************************************************************/
function in_array(haystack, needle, strict) {

    if (typeof strict === 'undefined') {
        strict = true;
    }

    return strict
        ? haystack.some(function (v) {
        return v === needle;
    })
        : haystack.some(function (v) {
        return needle.indexOf(v) !== -1;
    })
}

/******************************************************************
 *
 * 連想配列などのLengthはあてにならないので、サイズを取得する関数を用意する
 *
 ******************************************************************/
function sizeof(arr) {
    return Object.keys(arr).length;
}
/******************************************************************
 *
 * Trueかどうか。PHPからTrueで渡ってきた値がValidationを経て"1"に変わることが
 * あるため、こういった複雑な処理を挟む
 *
 ******************************************************************/
function is_true(flag) {
    return !!flag && (flag === true || flag === '1' || flag === 1);
}

/******************************************************************
 *
 * 存在チェック
 *
 ******************************************************************/
function exist($target) {
    return $target.length > 0 && sizeof($target) > 0;
}

/******************************************************************
 *
 * ランダム文字列生成
 *
 ******************************************************************/
function randStr() {
    var l = 8;

    // 生成する文字列に含める文字セット
    var c = "abcdefghijklmnopqrstuvwxyz0123456789";

    var cl = c.length;
    var r = "";
    for (var i = 0; i < l; i++) {
        r += c[Math.floor(Math.random() * cl)];
    }

    return r;
}

/******************************************************************
 *
 * xxx=xxx?xxx=xxx形式のパラメーターをJSONオブジェクトにして返す
 *
 ******************************************************************/

function paramsToJSON(params) {
    return JSON.parse('{"' + decodeURI(params).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}

/******************************************************************
 *
 * 円
 *
 ******************************************************************/
function currency(price) {
    return new Intl.NumberFormat("en", {
        style: "currency",
        currency: "JPY"
    }).format(price);
}